export default [
  'OneColumnDesktopLoginPage'
]

/*
Appears on:
/login-desktop
*/
